import { render, staticRenderFns } from "./ObjectFormButtons.vue?vue&type=template&id=fe92426a&scoped=true&"
import script from "./ObjectFormButtons.vue?vue&type=script&lang=js&"
export * from "./ObjectFormButtons.vue?vue&type=script&lang=js&"
import style0 from "./ObjectFormButtons.vue?vue&type=style&index=0&id=fe92426a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe92426a",
  null
  
)

export default component.exports